export default "__VITE_ASSET__EFYZhror__"